<template>
  <div>
    <el-dialog
      :visible.sync="showCloudDocument"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      right
      width="550px"
    >
      <div v-loading="confirmLoading">
        <div class="title" slot="title">
          <div class="close" @click="closeFn">
            <i class="icon"></i>
          </div>
        </div>
        <div>
          <iframe
            width="500"
            height="400"
            :src="`https://docs.foxitcloud.cn/selectFile/folderMul?limit=10`"
            frameborder="0"
          ></iframe>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="big" @click="closeFn">取 消</el-button>
          <el-button size="big" type="primary" @click.native="docsConvertFn"
            >确 定</el-button
          >
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import uploadMixin from "mixins/upload.js";
import { docsConvert, fileQuery } from "api/api";
export default {
  props: {
    showCloudDocument: {
      default: false,
      type: Boolean
    }
  },
  mixins: [uploadMixin],
  name: "cloudDocument",
  components: {},
  data() {
    return {
      confirmLoading: false,
      cloudDocumentFile: null
    };
  },
  methods: {
    //选择云文档转换
    docsConvertFn() {
      if (
        Object.prototype.toString.call(this.cloudDocumentFile) !==
          "[object Array]" ||
        this.cloudDocumentFile.length < 1
      )
        return this.$message.error("请先选择要打印的文档");
      const printableLength = this.uploadLists.filter(
        item => item.response && item.response.code === 0
      ).length;
      if (!this.isUploading) this.SET_IS_UPLOADING(true); // 显示上传列表
      if (10 - printableLength < this.cloudDocumentFile.length) {
        return this.$message.error("批量打印最多支持10个文件");
      }
      let queueParams = [];
      this.cloudDocumentFile.forEach(file => {
        const tempFile = {
          name: file.fileName,
          size: file.size,
          percentage: 100,
          docId: file.docId,
          uid: file.docId + new Date().getTime(), // 上传同个文件id重复所以增加时间戳
          response: {
            code: 0
          }
        };
        let fileListArr = [tempFile, ...this.uploadLists];
        // 更新上传进度列表
        this.SET_UPLOAD_LISTS(fileListArr);
        if (
          !this.allFileType.includes(this.interceptingFileTypes(tempFile.name))
        ) {
          this.setError(tempFile, "不支持的格式", true);
        } else {
          //文件大小
          let isAllowFileSize;
          for (let item of this.uploadMaxLimitSize) {
            if (item.paramKey === "uploadMaxLimit") {
              isAllowFileSize = tempFile.size < Number(item.paramValue);
            }
          }
          if (!isAllowFileSize) {
            this.setError(tempFile, "文件大小超出限制", true);
          } else {
            queueParams.push(tempFile);
          }
        }
      });
      if (queueParams.length > 0) {
        this.confirmLoading = true;
        Promise.all(queueParams.map(item => this.startUpload(item))).then(
          res => {
            this.confirmLoading = false;
            this.closeFn();
          }
        );
      } else {
        this.closeFn();
      }
    },
    startUpload({ docId, uid }) {
      return new Promise((resolve, reject) => {
        docsConvert({ docId })
          .then(res => {
            const { code, data, msg } = res;
            if (code === 0) {
              this.UPDATE_UPLOAD_FILE_PERCENTAGE({
                uid,
                response: {
                  data,
                  code: 0
                },
                percentage: 100
              });
            } else {
              this.setError(tempFile, msg || "网络错误，请重试", true);
            }
            resolve();
          })
          .catch(e => {
            this.setError(tempFile, (e && e.msg) || "网络错误，请重试", true);
            resolve();
          });
      });
    },
    //查询转换文档信息
    fileQueryFn(printNo) {
      this.confirmLoading = true;
      fileQuery(printNo)
        .then(res => {
          const { code, data } = res;
          if (code === 0) {
            if (data.status !== 6 && data.status !== 5) {
              this.fileQueryFn(printNo);
            } else {
              //上传成功，展示打印选项弹窗
              this.$emit("cloudDocumentUpload", true);
              sessionStorage.setItem("printParams", JSON.stringify(data));
              //关闭当前弹窗
              this.closeFn();
            }
          }
        })
        .catch();
    },
    //弹窗关闭
    closeFn() {
      this.$emit("update:showCloudDocument", false);
    }
  },
  created() {
    window.addEventListener(
      "message",
      res => {
        const { data } = res;
        if (Object.prototype.toString.call(data) === "[object Array]") {
          this.cloudDocumentFile = data;
        }
      },
      false
    );
  }
};
</script>

<style scoped lang="scss">
.dialog-footer {
  text-align: right;
  display: flex;
  justify-content: center;
  button {
    height: 40px;
    padding: 0 20px;
    font-size: 14px;
    margin-right: 20px;
    margin-top: 20px;
  }
}
</style>
